<template>
    <div>
        <el-container direction="vertical">
            <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
                <div style="margin-top: 20px;">
                    <el-form class="form" style="margin-left: 10px;">
                        <el-form-item label="患者姓名" style="width: 220px;">
                            <el-input v-model="listQuery.patientName"></el-input>
                        </el-form-item>
                        <el-form-item label="登记号" style="width: 220px;margin-left: 15px;">
                            <el-input v-model="listQuery.recordNo"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" style="width: 220px;margin-left: 15px;">
                            <el-input v-model="listQuery.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="来源" style="width: 160px;margin-left: 15px;">
                            <el-select v-model="listQuery.fromSource" placeholder="请选择" @change="deptIds = emptyDepartmentSelection(deptIds)">
                                <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label" :value="x.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="科室" style="width: 220px;margin-left: 15px;">
                            <el-select v-model="deptIds" multiple filterable clearable placeholder="请选择科室（可多选）">
                                <el-option v-for="x in filterDepartmentOptions(deptsOptions, listQuery.fromSource)" :key="x.value" :label="x.label" :value="x.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="检测时间" style="margin-left: 15px;">
                            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="协诊日期" style="margin-left: 15px;">
                            <el-date-picker v-model="codiagDateRange" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="预警" style="width: 160px;margin-left: 15px;">
                            <el-select v-model="listQuery.isCritical" placeholder="请选择" clearable>
                                <el-option label="预警" :value="1" />
                                <el-option label="非预警" :value="0" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="margin-left: 20px;" @click="getList">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" plain style="margin-left: 10px;margin-right: 20px;"
                                @click="handleReset">重置</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="handleExport">导出</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table ref="myTable" v-loading="listLoading" :data="manageList" border fit highlight-current-row
                        style="width:100%">
                        <el-table-column width="120px" align="center" label="姓名">
                            <template slot-scope="scope">
                                <span>{{ scope.row.patientName || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="120px" align="center" label="登记号">
                            <template slot-scope="scope">
                                <span>{{ scope.row.recordNo || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="60px" align="center" label="性别">
                            <template slot-scope="scope">
                                <span>{{ getGender(scope.row.gender) || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="60px" align="center" label="年龄">
                            <template slot-scope="scope">
                                <span>{{ getAge(scope.row.birthday) || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="150px" align="center" label="联系方式">
                            <template slot-scope="scope">
                                <span>{{ scope.row.phone || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="100px" align="center" label="预警">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.isCritical === 1" type="danger" size="small">预警</el-tag>
                                <el-tag v-else-if="scope.row.isCritical === 0" type="info" size="small">非预警</el-tag>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="150px" align="center" label="检测时间">
                            <template slot-scope="scope">
                                <span>{{ getParsedTime(scope.row.refTime) || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="248px" align="center" label="项目">
                            <template slot-scope="scope">
                                <span>{{ scope.row.examReportInfo?.reportName || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="115px" align="center" label="报告编号">
                            <template slot-scope="scope">
                                <span>{{ scope.row.examReportInfo?.reportCode || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="来源">
                            <template slot-scope="scope">
                                <span>{{ scope.row.fromSource || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="180px" align="center" label="科室">
                            <template slot-scope="scope">
                                <span>{{ scope.row.fromSourceDeptName || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="150px" align="center" label="协诊时间">
                            <template slot-scope="scope">
                                <span>{{ getParsedTime(scope.row?.codiagTime) || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="120px" align="center" label="状态">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.taskStatus === '协诊超时'" type="danger" size="small">{{ scope.row.taskStatus }}</el-tag>
                                <el-tag v-else-if="scope.row.taskStatus === '协诊'" type="primary" size="small">{{ scope.row.taskStatus }}</el-tag>
                                <el-tag v-else-if="scope.row.taskStatus === '待就诊'" type="warning" size="small">{{ scope.row.taskStatus }}</el-tag>
                                <span v-else>{{ scope.row.taskStatus || '-' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150px" align="center" label="手术情况">
                            <template slot-scope="scope">
                                <span>{{scope.row?.inhosLungInfo?.map(x => x.surgery_name_main)?.join(', ') || '-'
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="120px" align="center" label="病理类型">
                            <template slot-scope="scope">
                                <span>{{scope.row?.inhosLungInfo?.map(x => x.diag_name_pathology)?.join(', ') || '-'
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column fixed="right" width="250px" align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                                    @click="codiag(scope.row)">协诊详情</el-button>
                                <el-button style="margin-left: 0; padding: 0 4px;" type="text"
                                    @click="patientsDetail(scope.row)">健康档案</el-button>
                                <el-button v-if="scope.row.manageStatus === 'ACTIVE'"
                                    style="margin-left: 0; padding: 0 4px;" type="text"
                                    @click="handleTerminateManagement(scope.row)">终止管理</el-button>
                                <el-button v-else style="margin-left: 0; padding: 0 4px;" type="text"
                                    @click="bringUnderManagement(scope.row)">纳入管理</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail> -->

                    <patientLungDetail v-if="patientDetailVisible" ref="PatientDetailRef" />
                    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                        :limit.sync="listQuery.pageSize" @pagination="turnToPage" />
                    <codiagnosisModal v-if="codiagDiagVisible" ref="codiagDiagRef">
                    </codiagnosisModal>

                    <managementPlanModal v-if="managementPlanModalVisible" ref="managementPlanRef"
                        @upDataList="getList" />

                    <!-- 终止管理弹窗 -->
                    <el-dialog title="终止管理" :visible.sync="terminateDialogVisible" width="500px"
                        :close-on-click-modal="false" @close="terminateDialogClosed">
                        <el-form :model="terminateForm" :rules="terminateRules" ref="terminateFormRef">
                            <el-form-item label="患者姓名" label-width="100px">
                                <span>{{ terminatePatientName }}</span>
                            </el-form-item>
                            <el-form-item label="终止原因" prop="reason" label-width="100px">
                                <el-input type="textarea" v-model="terminateForm.reason" :rows="4"
                                    placeholder="请输入终止管理的原因" maxlength="500" show-word-limit>
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer">
                            <el-button @click="terminateDialogVisible = false">取消</el-button>
                            <el-button type="danger" @click="confirmTerminate" :loading="terminateLoading">确认终止</el-button>
                        </span>
                    </el-dialog>
                </div>
            </div>
        </el-container>
    </div>
</template>
<script>
import {
    getSearchList,
    turnToMyListCodiag,
    getUserInfos,
    exportLungCodiags,
    getSysDicList,
    getlistCodiags,
    getByIdCoDiag,
    getDoctorListQlyyDepts
} from "@/api/health/Patients";
import patientDetail from "@/views/patient/patientDetail";
import Pagination from "@/components/Pagination";
import patientTree from "@/components/selectTree";
import moment from "moment";
import codiagnosisModal from "../../components/codiagnosisModal/index.vue";
import patientLungDetail from "../patientLung/patientLungDetail.vue";
import managementPlanModal from "../../components/managementPlanModal/index.vue";
import { postTerminateManagement } from "@/api/health/Lung";
import { filterDepartmentOptions, emptyDepartmentSelection } from "@/utils/source-dept-filter";
import { downloadExcelBlob } from "@/utils/download-excel";

export default {
    components: { patientDetail, patientTree, Pagination, codiagnosisModal, patientLungDetail, managementPlanModal },
    data() {
        return {
            valueData: null,
            codiagDateRange: null,
            manageList: [],
            patientDetailVisible: false,
            codiagDiagVisible: false,
            managementPlanModalVisible: false,
            terminateDialogVisible: false,
            terminatePatientName: '',
            terminateCurrentIdcard: '',
            terminateForm: { reason: '' },
            terminateRules: { reason: [{ required: true, message: '请输入终止管理原因', trigger: 'blur' }] },
            terminateLoading: false,
            listLoading: false,
            total: 0,
            data: null,
            listQuery: {
                idcard: null,
                patientName: null,
                recordNo: null,
                noVisitHoursStart: null,
                noVisitHoursEnd: null,
                codiagHospital: null,
                codiagStatus: null,
                codiagStartTime: null,
                codiagEndTime: null,
                codiagDealResult: null,
                refStartTime: null,
                refEndTime: null,
                fromSource: null,
                fromSourceDeptId: null,
                phone: null,
                pageNum: 1,
                pageSize: 10,
                codiagServiceName: "肺结节协诊",
                codiagStatus: "完成",
                isCritical: null
            },
            sexOptions: [],
            sourceOptions: [],
            deptsOptions: [],
            deptIds: [],
        };
    },
    created() {
        var typeData = "性别";
        this.getSystemDictList(typeData);
        this.getSourceSystemDictList("指标来源");
        this.getMasterData('depts');
        this.getList();
    },
    methods: {
        filterDepartmentOptions,
        emptyDepartmentSelection,
        handleReset() {
            this.listQuery = {
                ...this.listQuery,
                patientName: null,
                codiagStartTime: null,
                codiagEndTime: null,
                phone: null,
                recordNo: null,
                fromSource: null,
                fromSourceDeptId: null,
                refStartTime: null,
                refEndTime: null,
                isCritical: null,
                pageNum: 1,
                pageSize: 10,
            }
            this.deptIds = [];
            this.valueData = null;
            this.codiagDateRange = null;
            this.getList();
        },
        async handleExport() {
            this.listQuery.fromSourceDeptId = this.deptIds.length ? this.deptIds.join(',') : null;
            this.listQuery.refStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
            this.listQuery.refEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;
            this.listQuery.codiagStartTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[0], 1) : null;
            this.listQuery.codiagEndTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[1], 2) : null;
            try {
                const data = await exportLungCodiags(this.listQuery);
                downloadExcelBlob(data, `肺结节已协诊_${moment().format('YYYYMMDDHHmm')}.xlsx`);
            } catch (error) {
                console.error(error);
                this.$message.error("导出失败");
            }
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
                console.log(this.sexOptions);
            }).catch(err => {
                console.log(err);
            })
        },
        getSourceSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
                this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
            }).catch(err => {
                console.log(err);
            })
        },
        async getMasterData(field, params) {
            try {
                if (field === 'depts') {
                    const res = await getDoctorListQlyyDepts({})
                    if (res.msg == "success") {
                        this.deptsOptions = [{ label: '全部', value: null }, ...res.data?.map(x => ({ label: x.deptName, value: x.deptId, type: x.type })) || []];
                    }
                }
            } catch (err) {
                console.warn(err);
            }
        },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        // 导航跳转查询列表页
        turnToPage() {
            this.listLoading = true;
            this.listQuery.fromSourceDeptId = this.deptIds.length ? this.deptIds.join(',') : null;
            this.listQuery.refStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
            this.listQuery.refEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;
            this.listQuery.codiagStartTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[0], 1) : null;
            this.listQuery.codiagEndTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[1], 2) : null;

            turnToMyListCodiag(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;
                }
            });
        },
        //一键协诊
        codiag(rowValue) {
            this.codiagDiagVisible = true;
            console.log('一键协诊：', rowValue);
            rowValue['isRead'] = true;
            this.$nextTick(() => {
                this.$refs['codiagDiagRef'].init(rowValue);
            })
        },
        //协诊-我管理的
        getList() {
            this.listLoading = true;
            this.listQuery.fromSourceDeptId = this.deptIds.length ? this.deptIds.join(',') : null;
            this.listQuery.refStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
            this.listQuery.refEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;
            this.listQuery.codiagStartTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[0], 1) : null;
            this.listQuery.codiagEndTime = this.codiagDateRange ? this.getParseDate(this.codiagDateRange[1], 2) : null;

            getlistCodiags(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;
                }
            });
        },
        // 計算年齡
        getAge(birthday) {
            if (birthday == null) return "";
            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        // 纳入管理：打开生成管理方案弹窗（新增）
        bringUnderManagement(row) {
            this.managementPlanModalVisible = true;
            this.$nextTick(() => {
                this.$refs["managementPlanRef"].init(row);
            });
        },
        // 终止管理
        handleTerminateManagement(row) {
            this.terminatePatientName = row.patientName || row.name || '';
            this.terminateCurrentIdcard = row.idcard || '';
            this.terminateForm.reason = '';
            this.terminateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs['terminateFormRef']?.clearValidate();
            });
        },
        confirmTerminate() {
            this.$refs['terminateFormRef'].validate((valid) => {
                if (!valid) return;
                this.terminateLoading = true;
                postTerminateManagement({
                    idcard: this.terminateCurrentIdcard,
                    reason: this.terminateForm.reason
                }).then(res => {
                    if (res.msg === 'success') {
                        this.$message.success('终止管理成功');
                        this.terminateDialogVisible = false;
                        this.getList(); // 刷新列表
                    } else {
                        this.$message.error(res.msg || '终止管理失败');
                    }
                }).catch(err => {
                    console.error(err);
                    this.$message.error('终止管理失败');
                }).finally(() => {
                    this.terminateLoading = false;
                });
            });
        },
        terminateDialogClosed() {
            this.terminateForm.reason = '';
            this.$refs['terminateFormRef']?.clearValidate();
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
        },
        getParsedTime(time) {
            if (!time) return null;
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
    },
};
</script>
<style lang="scss" scoped>
.form {
    display: flex;
    flex-wrap: wrap;

    ::v-deep {
        .el-form-item {
            margin-left: 5px;
        }

        .el-form-item__content {
            display: flex;
        }
    }
}
</style>
